<template>
  <b-navbar toggleable="lg" type="dark" variant="info" fixed="top" >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar-brand id="brand-link" class="navbar-brand" to="/">新元号.jp</b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
         <b-navbar-nav small>
            <b-nav-item :active="true" to="/news">ニュース</b-nav-item>
            <b-nav-item :active="false" to="/shopping">ショッピング</b-nav-item> 
            <b-nav-item :active="false" to="/about">このサイトについて</b-nav-item>          
         </b-navbar-nav>
        <b-navbar-nav class="ml-auto" small>
          <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">検索</b-button>
            
          </b-nav-form>
          
          <b-navbar-nav v-if="profile.user" class="small">
            <b-nav-item-dropdown>
              <!-- Using 'button-content' slot -->
              <template slot="button-content">
                <img :src="profile.user.photoURL" width="32"/>&nbsp;
                <em>{{profile.user.displayName}}</em>
              </template>
              <b-dropdown-item href="#" class="small">プロフィール</b-dropdown-item>
              <b-dropdown-item href="#" class="small" v-on:click="signOut" >サインアウト</b-dropdown-item>
            </b-nav-item-dropdown>
          
          </b-navbar-nav>
          <b-navbar-nav v-else class="small">
            <b-nav-item :active="true" to="/signin">サインイン</b-nav-item>
          </b-navbar-nav>

          
          
        </b-navbar-nav>
      </b-collapse>
  </b-navbar>
</template>


<script>
  import auth from '../auth.js'

  export default {
    data: function() {
      return {
        profile: this.$profile
      }
    },
    methods: {
      signOut() {
        auth.signOut(this);
        
      }
    }
  }
</script>


<style>
#brand-link a {
  color: red !important;
}
</style>

